import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetSettingsCall} from "../../apis/live";
import {GENERIC_ERROR} from "../../constants/ErrorConstants";
import {GET_LIVE_SETTINGS_SUCCESS} from "../../constants/LiveConstants";

function* tryFunction(template: string) {
    const settings: Record<string, string> = yield call(GetSettingsCall, template);
    yield put({
        type: GET_LIVE_SETTINGS_SUCCESS,
        payload: {template, settings}
    });
}

export function* getSettingSaga({payload}: { payload: string }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: payload},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}
